/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { generateTrackerLink } from '~helpers/generators';
import { getLink } from '../../../../helpers/rotate-links';

const Tracker = ({ pageContext, path }) => {
  const redirect = () => {
    if (typeof window !== 'undefined') {
      if (pageContext.isLiveStreamProvider) {
        window.location.href = getLink(pageContext.provider, localStorage.getItem('pageTemplate'));
      } else {
        const { operator } = pageContext;
        const trackerLinks = operator ? Object.keys(operator.links) : [];

        let tracker = '';
        for (let i = 0; i < trackerLinks.length; i += 1) {
          const trackerLink = trackerLinks[i].toLowerCase().replace(' ', '_');

          if (generateTrackerLink(operator, trackerLink) === path) {
            tracker =
              operator.links[
                Object.keys(operator.links).find(
                  (key) => key.toLowerCase() === trackerLink.toLowerCase()
                )
              ];
          }
          if (tracker !== '') {
            tracker = operator.links.main;
            window.location.href = tracker;
          }
        }
      }
    }
  };
  redirect();
  return <></>;
};

Tracker.propTypes = {
  path: PropTypes.string,
  pageContext: PropTypes.shape({
    isLiveStreamProvider: PropTypes.bool,
    operator: PropTypes.shape({
      links: PropTypes.arrayOf(PropTypes.string),
    }),
    pageType: PropTypes.string,
    provider: PropTypes.shape({
      links: PropTypes.shape({
        static: PropTypes.shape({}),
        campaigns: PropTypes.shape({}),
      }),
      name: PropTypes.string,
    }),
  }),
};

export default Tracker;
